<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Email Setup ')"
          icon="mdi-account-tie"
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-card class="px-5" v-for="email in smtpCredentials" :key="email.country">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$i18n.t('SMTP Email')"
                  class="purple-input"
                  v-model="email.smtpEmail"
                ></v-text-field>
                <v-text-field
                  :label="$i18n.t('SMTP UserName')"
                  class="purple-input"
                  v-model="email.smtpUsername"
                ></v-text-field>
                <v-text-field
                  :label="$i18n.t('SMTP Password')"
                  class="purple-input"
                  v-model="email.smtpPassword"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$i18n.t('SMTP Host')"
                  class="purple-input"
                  v-model="email.smtpHost"
                ></v-text-field>
                <v-text-field
                  :label="$i18n.t('SMTP Port')"
                  class="purple-input"
                  v-model="email.port"
                  number
                ></v-text-field>

                <v-select :items="sslTypes" :label="$i18n.t('Solo field')" v-model="email.smtpType"></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <z-country-select class="purple-input" v-model="email.country"></z-country-select>
                <z-city-select
                  class="purple-input"
                  v-model="email.cityGroup"
                  multiple
                  :country="email.country"
                />
              </v-col>
              <!-- <v-col cols="12" md="2">
                <z-client-select
                  class="purple-input"
                  v-model="email.client_id"
                />
              </v-col>-->

              <v-col cols="12" md="1">
                <v-checkbox v-model="email.isDefault" :label="$i18n.t('Default')"></v-checkbox>
              </v-col>
              <v-col cols="12" md="1">
                <v-btn @click="remove()" fab text small color="danger" class="mt-3">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
          <v-row class="text-right">
            <v-col>
              <v-btn small fab class="float-right" color="blue" @click="add()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-col cols="12" class="text-right">
            <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  corporateConfig = {
    smtpCredentials: [],
  };
  url = "/api/corp/config/get";
  sslTypes = ["SSL", "TLS"];
  smtpCredentials = [];

  get loading() {
    return common.loading;
  }

  add() {
    if (this.smtpCredentials == null) {
      this.smtpCredentials = [];
    }

    this.smtpCredentials.push({
      isDefault: false,
    });
  }

  async mounted() {
    try {
      this.corporateConfig = await doGet(this.url);
      this.smtpCredentials = this.corporateConfig.smtpCredentials;
    } catch (e) {
      common.setError(e.message);
    }
  }
  remove(_index) {
    this.smtpCredentials.splice(_index, 1);
  }

  async save() {
    try {
      common.setLoading(true);
      this.corporateConfig.smtpCredentials = this.smtpCredentials;
      // console.log(this.corporateConfig);
      await doPost("/api/corp/config/smtpCred/save", this.corporateConfig);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
